/** Platforma tabs — platform-admin-only administration across all companies. */
export type PlatformaTab = 'firmy' | 'uzivatele' | 'ulohy' | 'pujcovna' | 'diagnostika';

export const PLATFORMA_TABS: readonly PlatformaTab[] = ['firmy', 'uzivatele', 'ulohy', 'pujcovna', 'diagnostika'];

export interface PlatformaSearch {
  tab?: PlatformaTab;
}

export function parsePlatformaSearch(input: Record<string, unknown>): PlatformaSearch {
  const raw = input.tab;
  return PLATFORMA_TABS.includes(raw as PlatformaTab) ? { tab: raw as PlatformaTab } : {};
}
